import { useModal } from "../../context/Modal/ModalContext";
import styles from "./Footer.module.scss";
import clsx from "clsx";

const Footer = () => {
  const { openModal } = useModal();

  return (
      <div className={styles.container}>
        <div className={styles.inner}>
          <section className={styles.infoBox}>
            <button
                className={styles.infoBox__button}
                onClick={() => {
                  openModal({
                    type: "TermsServiceModal",
                  });
                }}
            >
              이용약관
            </button>
            <button
                className={styles.infoBox__button}
                onClick={() => {
                  openModal({
                    type: "TermsInfoCustomer",
                  });
                }}
            >
              개인정보처리방침
            </button>
          </section>
          <section className={styles.infoBox}>
          <span className={styles.infoBox_txt}>
            부산 해운대구 센텀서로 30 케이엔엔타워 26층
          </span>
          </section>
          <section className={styles.infoBox}>
            <div className={styles.infoBox_first}>
              <strong className={styles.infoBox_title}>대표</strong>
              <span className={styles.infoBox_txt}>권이형</span>
            </div>
            <div>
              <strong className={styles.infoBox_title}>사업자등록번호</strong>
              <span className={styles.infoBox_txt}>114-81-93597</span>
            </div>
          </section>
          <section className={clsx(styles.infoBox, styles.infoBoxSpecial)}>
            <div className={styles.infoBox_first}>
              <strong className={styles.infoBox_title}>대표전화</strong>
              <span className={styles.infoBox_txt}>051-747-8774</span>
            </div>
            <div>
              <strong className={styles.infoBox_title}>이메일</strong>
              <span className={styles.infoBox_txt}>
              smartwork@smartworkoffice.co.kr
            </span>
            </div>
          </section>
          <section className={styles.infoBox}>
            <div>
              <strong className={styles.infoBox_title}>상담 운영 시간</strong>
              <span className={styles.infoBox_txt}>
              평일 9:00~18:00 (주말 휴무)
            </span>
            </div>
          </section>
        </div>
      </div>
  );
};

export default Footer;
